module.exports = __webpack_public_path__ + "static/media/location.7a62ecaa.png";